import { useParams } from 'react-router-dom';
import { WizardLayout } from '../../components/wizard/WizardLayout';
import { WizardStep } from '../../components/wizard/WizardStep';
import { useWizardStore } from '../../lib/store/wizard';
import { de } from '../../lib/i18n/de';

const OPTIONS = [
  { value: 'par10', label: de.steps.triage.legalBasisOptions.par10 },
  { value: 'par16b', label: de.steps.triage.legalBasisOptions.par16b },
  { value: 'par16c', label: de.steps.triage.legalBasisOptions.par16c },
  { value: 'par93', label: de.steps.triage.legalBasisOptions.par93 },
  { value: 'unsure', label: de.steps.triage.legalBasisOptions.unsure },
] as const;

/**
 * Triage – erste Einordnung des Falls. AP6-Stub: ein einziges Auswahlfeld
 * (Rechtlicher Rahmen). Die volle Triage-Logik (B2C/B2G-Discriminator, Mandant
 * vs. Jobcenter-Kontaktdaten) folgt in Phase 2.
 */
export function TriageStep() {
  const { id: caseId = 'demo' } = useParams<{ id: string }>();
  const triage = useWizardStore((s) => s.cases[caseId]?.triage);
  const lastSavedAt = useWizardStore((s) => s.cases[caseId]?.lastSavedAt) ?? null;
  const setTriage = useWizardStore((s) => s.setTriage);

  const value = triage?.legalBasis ?? '';
  const canProceed = value.length > 0;

  // TODO(@tragfaehigkeit/core): zod-Validation gegen `LegalBasisSchema` einbinden
  // sobald die Triage-Schemas im Core-Paket finalisiert sind.

  return (
    <WizardLayout>
      <WizardStep
        stepId="triage"
        canProceed={canProceed}
        lastSavedAt={lastSavedAt}
        saveState={lastSavedAt ? 'saved' : 'idle'}
      >
        <fieldset>
          <legend className="font-sans text-xs font-medium uppercase tracking-widest text-stone-500">
            {de.steps.triage.legalBasisLabel}
          </legend>
          <p className="mt-2 font-serif text-sm italic text-stone-500">
            {de.steps.triage.legalBasisHint}
          </p>
          <div className="mt-6 space-y-3">
            {OPTIONS.map((opt) => {
              const checked = value === opt.value;
              return (
                <label
                  key={opt.value}
                  className={`flex cursor-pointer items-start gap-4 rounded-sm border px-5 py-4 transition-colors ${
                    checked
                      ? 'border-stone-900 bg-stone-50'
                      : 'border-stone-200 bg-white hover:bg-stone-50/60'
                  }`}
                >
                  <input
                    type="radio"
                    name="legalBasis"
                    value={opt.value}
                    checked={checked}
                    onChange={(e) => {
                      // Auto-Save-Stub: bei Auswahl direkt in den Store schreiben
                      setTriage(caseId, { legalBasis: e.target.value });
                    }}
                    className="mt-1 h-4 w-4 cursor-pointer accent-stone-900"
                  />
                  <span className="font-serif text-base leading-snug text-stone-900">
                    {opt.label}
                  </span>
                </label>
              );
            })}
          </div>
        </fieldset>
      </WizardStep>
    </WizardLayout>
  );
}
